import { combineReducers } from "redux";
import bodyshock from "../bodyshock/Products";
export default combineReducers({
  bodyshock,
});
